import { getClient } from './client-helper';
import { ReadBookingResult } from './dtos';

export async function getBooking(bookingNumber: number, signal?: AbortSignal) {
  const { gatewayApiUri, authToken } = await getClient();

  const response = await fetch(`${gatewayApiUri}/booking/${bookingNumber}`, {
    signal,
    headers: { Authorization: `Bearer ${authToken}` },
  });

  if (!response.ok) {
    throw new Error(`failed to get booking: ${response.statusText}`, {
      cause: response.status
    });
  }

  const result: ReadBookingResult = await response.json();

  return result.booking;
}

